<template>
  <div v-if="blog" class="blog">
    <div class="industury__topbanner">
       <ul v-if="$root.globalData">
        <li>{{$root.globalData.keys.blog_text}}</li>
        <span> <DoubleLeftAroow /> </span>
        <li>
          <router-link style="color: white" to="/"> {{$root.globalData.keys.home_index_text}} </router-link>
        </li>
      </ul>
    </div>
    <div id="content">
      <div id="leftBox">
        <div id="imageBox">
          <img :src="blog.image" :alt="blog.title" />
          <p>
            <span>{{
              $cookie.get("language") == "en" ? "categories:" : "دسته بندی :"
            }}</span>
            <router-link :to="`/blog?categoryId=${blog.category.id}`">
              {{ blog.category.name }}
            </router-link>
          </p>
        </div>
        <div v-if="blogList" class="hiddenInMobile" id="relatedPosts">
          <h4>
            {{
              $cookie.get("language") == "en" ? "related posts" : "مقالات مرتبط"
            }}
          </h4>
          <div
            class="relatedPostCard"
            v-for="(item, index) in blogList"
            :key="index"
          >
            <h6>{{ item.title }}</h6>
            <div>
              <span>
                {{
                  $cookie.get("language") == "en"
                    ? new Date(item.created_at).toLocaleDateString("en")
                    : new Date(item.created_at).toLocaleDateString("fa")
                }}
              </span>
              <router-link
              v-if="$root.globalData"
                target="_blank"
                :to="`/blog/${item.id}/${slugGenerator(item.title)}`"
              >
{{$root.globalData.keys.show_more_text}}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div id="rightBox">
        <h1 class="blogTitle">
          {{ blog.title }}
        </h1>
        <div v-html="blog.body" class="blogDetailContent"></div>
           <div v-if="blogList" class="showInMobile" id="relatedPosts">
          <h4>
            {{
              $cookie.get("language") == "en" ? "related posts" : "مقالات مرتبط"
            }}
          </h4>
          <div
            class="relatedPostCard"
            v-for="(item, index) in blogList"
            :key="index"
          >
            <h6>{{ item.title }}</h6>
            <div>
              <span>
                {{
                  $cookie.get("language") == "en"
                    ? new Date(item.created_at).toLocaleDateString("en")
                    : new Date(item.created_at).toLocaleDateString("fa")
                }}
              </span>
              <router-link v-if="$root.globalData"
                target="_blank"
                :to="`/blog/${item.id}/${slugGenerator(item.title)}`"
              >
              {{$root.globalData.keys.show_more_text}}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loader v-else />
</template>

<script>
import DoubleLeftAroow from "../components/svgs/DoubleLeftAroow.vue";

import Loader from "../components/loader.vue";
import BlogSlider from "../components/main/BlogSlider.vue";
import StarIcon from "../components/svgs/StarIcon.vue";
import BlogDesc from "../components/main/BlogDesc.vue";
import Image from "../assets/images/googlemap.jpg";
import Telegram from "../components/svgs/Telegram.vue";
import Instagram from "../components/svgs/Instagram.vue";
import ShareIcon from "../components/svgs/ShareIcon.vue";
import BlogForm from "../components/main/BlogForm.vue";
export default {
  data() {
    return {
      LocationImage: Image,
      Starcount: 5,
      blogList:null,
      blogTilte: "کارخانه ذوب آهن اصفهان"
    };
  },
  computed:{
    blog(){
      return this.$store.getters.getSingleBlog;
    }
  },
  mounted() {
    this.$store.dispatch("getSingleBlogFromServer",this.$route.params.id);
    this.$axios.get("front/randomPosts").then((res) => {
      this.blogList = res.data.posts;
    });
  },
  methods: {
    slugGenerator(name) {
      if (name == null) return name;
      let result = " ";
      result = name.replace(/ /g, "-");
      return result;
    }
  },
  components: {
    Loader,
    BlogSlider,DoubleLeftAroow,
    StarIcon,
    BlogDesc,
    Telegram,
    Instagram,
    ShareIcon,
    BlogForm
  },
  
  metaInfo() {
        return { 
            title: "وبلاگ",
            meta: [
                { name: 'description', content:  'وبلاگ'},
                { property: 'og:title', content: "وبلاگ"},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>

<style scoped>
.industury__topbanner {
  width: 100%;
  height: 200px;
  background-image: url(../assets/images/industrybanner.jpg);
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: multiply;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 1155px) {
  .industury__topbanner {
    display: none;
  }
}
div#content {
  display: flex;
  justify-content: space-between;
  width: 98%;
  margin: 50px auto;
}
div#leftBox {
  width: 35%;
}
div#rightBox {
  width: 65%;
  padding: 0 30px;
}
div#imageBox {
  width: 80%;
  margin: auto;
}
div#imageBox p {
  text-align: right;
  direction: rtl;
}
div#imageBox img {
  width: 100%;
  border-radius: 15px;
}
div#relatedPosts {
  width: 80%;
  margin: auto;
}
div#relatedPosts h4 {
  text-align: right;
  color: #0097d7;
}
.relatedPostCard {
  background: white;
  border-radius: 8px;
  padding: 5px;
  box-shadow: 0 0 10px #00000030;
  margin: 10px 0;
}
.relatedPostCard h6 {
  text-align: right;
  padding: 10px 0;
}
.relatedPostCard div a {
  color: black;
}
.relatedPostCard div {
  display: flex;
  width: 95%;
  margin: auto;
  justify-content: space-between;
}
.showInMobile{
  display:none;
}
@media (max-width: 768px) {
  .showInMobile{
    display:block;
  }
  .hiddenInMobile{
    display: none;
  }
  div#content {
    display: flex;
    flex-direction: column;
    width: 98%;
    margin: 50px auto;
  }
  div#leftBox {
    width: 100%;
  }
  div#rightBox {
    width: 100%;
  }
  .blogTitle h1{
    font-size:16px;
  }
  @media (max-width:768px){
    .blogTitle{
      font-size:18px;
    }
  }
}
</style>
